import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173'),
	() => import('./nodes/174'),
	() => import('./nodes/175')
];

export const server_loads = [0,2,3,4,9,10];

export const dictionary = {
		"/": [~11],
		"/activity/detail": [~29],
		"/auth/index": [30,[2]],
		"/auth/login": [31,[2]],
		"/auth/reg": [32,[2]],
		"/auth/reset": [33,[2]],
		"/auth/security": [34,[2]],
		"/a/ActivityRedPacket": [12],
		"/a/animate/FlipAnimate": [13],
		"/a/block": [14],
		"/a/button": [15],
		"/a/checkbox": [16],
		"/a/date-picker": [17],
		"/a/del": [18],
		"/a/modal": [19],
		"/a/overlay": [20],
		"/a/picker-column": [22],
		"/a/picker": [21],
		"/a/popup": [23],
		"/a/svg": [24],
		"/a/test": [25],
		"/a/time": [26],
		"/a/toaster": [27],
		"/a/wave-progress": [28],
		"/ball": [~35],
		"/ball/detail": [~36],
		"/bbs": [~37],
		"/bbs/detail": [~38],
		"/bbs/exchange": [~39],
		"/bbs/exchange/chat": [~40],
		"/bbs/his": [~41],
		"/bbs/home": [~42],
		"/bbs/pick-code": [~43],
		"/bbs/pick-share": [~44],
		"/bbs/posts": [~45],
		"/bbs/square": [~46],
		"/bbs/square/release": [~47],
		"/bbs/square/user": [~48],
		"/bbs/statistics": [~49],
		"/bbs/toolbox": [~50],
		"/bbs/toolbox/birthday": [~51],
		"/bbs/toolbox/family": [~52],
		"/bbs/toolbox/his": [~53],
		"/bbs/toolbox/kill-number": [~54],
		"/bbs/toolbox/query-assistant": [~55],
		"/bbs/toolbox/shake": [~56],
		"/bbs/toolbox/spouse": [~57],
		"/bbs/toolbox/virtue": [~58],
		"/bbs/toolbox/zodiac": [~59],
		"/liveplay/10": [64,[3]],
		"/liveplay/vis": [~65,[3]],
		"/live": [~60],
		"/live/more": [~61],
		"/live/rank": [62],
		"/live/streaming": [~63],
		"/lottery/bettingMain/[seriesTag]/[lotteryId]": [66,[4]],
		"/lottery/bettingToday": [67,[4]],
		"/lottery/chatRoomList": [~69,[4]],
		"/lottery/chatRoom": [~68,[4]],
		"/lottery/groupNoticeDetail": [71,[6]],
		"/lottery/groupNotice": [~70,[5]],
		"/lottery/historyTrend": [~72,[4]],
		"/maintain": [73],
		"/my": [~74,[7]],
		"/my/about": [~75,[7]],
		"/my/activities": [~76,[7]],
		"/my/activities/detail": [~77,[7]],
		"/my/activities/redpacket": [~78,[7]],
		"/my/cards": [~79,[7]],
		"/my/cards/add": [~80,[7]],
		"/my/cards/bind": [81,[7]],
		"/my/coupons": [~82,[7]],
		"/my/coupons/expired": [~83,[7]],
		"/my/coupons/history": [~84,[7]],
		"/my/daily": [~85,[7]],
		"/my/language": [86,[7]],
		"/my/loan": [~87,[7]],
		"/my/loan/borrow": [~88,[7]],
		"/my/loan/detail": [~89,[7]],
		"/my/loan/instruction": [~90,[7]],
		"/my/loan/repay": [~91,[7]],
		"/my/points": [~92,[7]],
		"/my/points/detail": [~93,[7]],
		"/my/points/goods": [~94,[7]],
		"/my/points/orders": [~95,[7]],
		"/my/profile": [~96,[7]],
		"/my/profile/avatar": [~97,[7]],
		"/my/profile/info": [~98,[7]],
		"/my/profile/nickname": [~99,[7]],
		"/my/profile/password": [~100,[7]],
		"/my/profile/phone": [~101,[7]],
		"/my/profile/realname": [~102,[7]],
		"/my/profile/withdrawal": [~103,[7]],
		"/my/recharge": [~104,[7]],
		"/my/recharge/abpay": [~105,[7]],
		"/my/recharge/abpay/order": [~106,[7]],
		"/my/recharge/abpay/pay": [~107,[7]],
		"/my/recharge/alipay": [108,[7]],
		"/my/recharge/bank": [~109,[7]],
		"/my/recharge/bank/confirm": [~110,[7]],
		"/my/recharge/detail": [~111,[7]],
		"/my/recharge/online": [112,[7]],
		"/my/recharge/other": [~113,[7]],
		"/my/recharge/transfer": [114,[7]],
		"/my/recharge/usdt": [~115,[7]],
		"/my/report": [~116,[7]],
		"/my/service": [~117,[7]],
		"/my/service/chat": [~118,[7]],
		"/my/service/device": [~119,[7]],
		"/my/share": [~120,[7]],
		"/my/share/commission": [~121,[7]],
		"/my/share/members": [~122,[7]],
		"/my/share/search": [123,[7]],
		"/my/share/stats": [~124,[7]],
		"/my/sports/experts": [125,[7]],
		"/my/sports/results": [126,[7]],
		"/my/sports/rules": [~127,[7]],
		"/my/tasks": [128,[7]],
		"/my/vip": [~129,[7]],
		"/my/vip/instruction": [~130,[7]],
		"/my/vip/maintain": [~131,[7]],
		"/my/vip/record": [~132,[7]],
		"/my/vip/redpacket": [~133,[7]],
		"/my/wallet": [~134,[7]],
		"/my/wallet/currency": [~135,[7]],
		"/my/wallet/edit": [~136,[7]],
		"/my/wallet/transactions": [~137,[7]],
		"/my/wallet/virtual": [~138,[7]],
		"/my/wallet/virtual/add": [~139,[7]],
		"/my/withdraw": [~140,[7]],
		"/my/withdraw/add-alipay": [~141,[7]],
		"/my/withdraw/add-bank": [~142,[7]],
		"/my/withdraw/add-digital": [~143,[7]],
		"/my/withdraw/add-wechat": [~144,[7]],
		"/my/withdraw/alipay": [~145,[7]],
		"/my/withdraw/bank": [~146,[7]],
		"/my/withdraw/digital": [~147,[7]],
		"/my/withdraw/home": [~148,[7]],
		"/my/withdraw/wechat": [~149,[7]],
		"/notice": [~150,[8]],
		"/notice/detail": [~151,[8]],
		"/picture": [~152],
		"/picture/detail": [~153],
		"/play": [154,[9]],
		"/record/game/list": [~155],
		"/record/list": [~156],
		"/record/lottery": [~157],
		"/record/lottery/lotteryDetail": [~158],
		"/sports/list": [~159,[10]],
		"/sports/list/expert": [~160,[10]],
		"/sports/list/push": [~161,[10]],
		"/sports/list/ranking": [~162,[10]],
		"/sports/lottery/ball": [~163],
		"/sports/lottery/ball/detail": [~164],
		"/sports/lottery/record": [~165],
		"/sports/lottery/record/detail": [~166],
		"/sports/push": [~167],
		"/sports/push/betting": [~168],
		"/sports/push/detail": [~169],
		"/sports/push/expert": [~170],
		"/sports/push/great-god": [~171],
		"/sports/push/result": [~172],
		"/test": [173],
		"/test/aa": [174],
		"/thirdGame": [~175]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';